import ListStore from '@/store/core/ListStore';
import { action, computed, observable, override } from 'mobx';
import services from '@/api/services';
import { startDate, endDate } from '@/utils/date';
import { Taxpayers } from '@/store/types';
import { taxpayerTypes } from '@/store/mapping';
import { dateFormat, numGroup } from '@/utils/filters';
import { PageableQueryParams } from '@/types/pagination';

const defaultFilters = {
  name: '',
  tin: '',
  nameTin: '',
  createDate: '',
  createType: '',
  type: null,
  status: null,
  isExceed: false,
  startDate,
  endDate,
};

interface Taxpayer {
  iin: string;
  balance: number;
  exemption: number;
  income: number;
  tax: number;
  taxWithExemption: number;
}

export default class TaxpayersStore extends ListStore<{
  items: Array<Taxpayer>;
  totalSumIncome?: number;
  totalSumTax?: number;
}> {
  @override
  filters = JSON.parse(JSON.stringify(defaultFilters));
  @observable overall = {
    totalIncome: 0,
    totalTax: 0,
  };

  @override
  pageable: PageableQueryParams = {
    limit: 20,
    direction: 'DESC',
    page: 1,
    sortBy: 'createDate',
  };

  sortColumns: (keyof Taxpayers)[] = [
    'createDate',
    'name',
    'createType',
    'sumIncome',
    'sumTax',
    'incomeYear',
    'taxYear',
    'totalDebt',
    'totalSumTax',
    'totalSumIncome',
  ];

  @computed get processedData() {
    if (!this.data?.items || !this.data?.items?.length) return;
    const items: any[] = this.data.items.map((item: Taxpayer) => ({
      ...item,
      balance: numGroup(item.balance),
      tax: numGroup(item.tax),
      exemption: numGroup(item.exemption),
      taxWithExemption: numGroup(item.taxWithExemption),
      income: numGroup(item.income),
    }));
    return { ...this.data, items };
  }

  @action.bound async fetch() {
    this.isFetching = true;
    try {
      const {
        data: { totalIncome, totalTax, ...data },
      } = await services.admin.getTaxpayersList(this.notFalsyParams);
      this.data = data;
      this.overall = { totalIncome, totalTax };
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }

  @action resetFilters() {
    this.filters = JSON.parse(JSON.stringify(defaultFilters));
  }
}
